<template>
  <font-awesome-icon
    icon="house-user"
    class="fa" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faHouseUser } from '@fortawesome/free-solid-svg-icons'

library.add(faHouseUser)

export default {
  name: 'CoozzyHouseUserIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-text-grey;
  }
</style>
